import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import PageHeader from "@/ui-elements/page-header/PageHeader.vue"
import { useRouter } from "vue-router"
import { computed, ComputedRef, onMounted } from "vue"
import PinCodeModal from "@/app/PinCodeModal.vue"
import FileBrowser from "@/ui-elements/file-browser/FileBrowser.vue"
import EmergencyBrakeModal from "@/pages/orders/modals/brake/EmergencyBrakeModal.vue"
import { RiceCooker } from "@/riceCooker/riceCooker"
import CustomerModal from "@/pages/pos/modal/customer/CustomerModal.vue"
import { setToastNotification } from "@/ui-elements/toast-notification/setToastNotification"
import { useI18n } from "vue-i18n"
import { setFontSizeOnHTML, useFontSize } from "@/store/FontSize"
import { useAPIStore } from "@/store/API"
import { useUserStore } from "@/store/User"
import { useFileBrowserStore } from "@/store/fileBrowserStore"
import { useOrdersStore } from "@/store/Orders"
import OrderModal from "@/pages/orders/modals/order/OrderModal.vue"
import { useBrakeStore } from "@/store/Brake"
import { useCustomerModalStore } from "@/store/CustomerModal"
import "shepherd.js/dist/css/shepherd.css"
import CustomerReceiptConfirmation from "@/pages/pos/components/CustomerReceiptConfirmation.vue"
import { useCustomerReceiptStore } from "@/store/CustomerReceiptConfirmation"
import ConfirmationModal from "@/ui-elements/layout/modals/ConfirmationModal.vue"
import { useOrderWarningStore } from "@/store/OrderWarning"
import AdminClientInfoModal from "@/app/admin-client-info-modal/AdminClientInfoModal.vue"
import { useSettingsStore } from "@/store/Settings"
import RiceCookerUpdateModal from "@/components/RiceCookerUpdateModal.vue"
import SystemSetupMasterSlaveModal from "@/app/SystemSetupMasterSlaveModal.vue"
import {
    updateLocaleSettings,
    useLocalLocales,
} from "@/pages/auth/useLocalLocales"
const bg_path = "/assets/images/auth-bg.png"


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderbuddyApp',
  setup(__props) {

const { t: translate } = useI18n()
const fontSize = useFontSize()
setFontSizeOnHTML(fontSize.getSize())
const router = useRouter()
const settings = useSettingsStore()
const userStore = useUserStore()
const ordersStore = useOrdersStore()

if (RiceCooker.isPresent() && !localStorage.getItem("localStorageSynced")) {
    RiceCooker.syncLocalStorage()
}

const { getDefaultLocale } = useLocalLocales()

// We do show the modal if you haven't confirmed yet you want to be slave, and
// we show the modal so you can confirm you want to overwrite the current master
const showMasterSlaveSetup: ComputedRef<boolean> = computed(
    () =>
        Boolean(Number(useSettingsStore().settings.masterslave)) &&
        ((!useUserStore().hasConfirmedSlaveRecently &&
            (useSettingsStore().settings.master_ob_id === null ||
                useSettingsStore().settings.master_ob_id === undefined)) ||
            useUserStore().confirm_overwrite_master)
)

onMounted(async () => {
    updateLocaleSettings(getDefaultLocale())
})

const apiStore = useAPIStore()
const fileBrowserStore = useFileBrowserStore()
const customerStore = useCustomerModalStore()
const customerReceiptStore = useCustomerReceiptStore()
const brakeStore = useBrakeStore()
const warningStore = useOrderWarningStore()

const page = computed(() => {
    const currentRoute = router.currentRoute.value
    if (currentRoute && currentRoute.matched.length) {
        return currentRoute.meta.name
    } else {
        return undefined
    }
})

const pagesWithoutMenu = [
    "auth",
    "numberBuddy",
    "impersonation",
    "clientSso",
    "customerScreen",
]

const showMenu = computed(
    () =>
        !pagesWithoutMenu.includes(page.value as string) &&
        apiStore.hasBearerToken()
)
const showModals = computed(() => page.value !== "auth")
onMounted(() => {
    if (settings.pos2Screen) {
        RiceCooker.openCustomerScreen()
    }

    window.addEventListener("pos_2ndscreen-updated", (event: CustomEvent) => {
        if (event.detail) {
            RiceCooker.openCustomerScreen()
        }
    })
})

window.onerror = (message) => {
    const genericMessage = translate("please_try_again")
    const content = message ? `${genericMessage} (${message})` : genericMessage
    setToastNotification(translate("something_went_wrong"), content, "danger")
    return true
}

window.onunhandledrejection = (errorEvent) => {
    const genericMessage = translate("please_try_again")
    const content = errorEvent.reason
        ? `${genericMessage} (${errorEvent.reason})`
        : genericMessage
    setToastNotification(translate("something_went_wrong"), content, "danger")
    return true
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["wrap", page.value])
    }, [
      (showMenu.value)
        ? (_openBlock(), _createBlock(PageHeader, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "page grid grid-cols-10",
        style: _normalizeStyle(
                page.value === 'auth' ? 'background-image: url(' + bg_path + ')' : ''
            )
      }, [
        _createVNode(_component_router_view)
      ], 4)
    ], 2),
    (showModals.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_unref(apiStore).requirePincode)
            ? (_openBlock(), _createBlock(PinCodeModal, { key: 0 }))
            : _createCommentVNode("", true),
          (
                showMasterSlaveSetup.value &&
                _unref(useUserStore)().togglingMasterSlave === false
            )
            ? (_openBlock(), _createBlock(SystemSetupMasterSlaveModal, { key: 1 }))
            : _createCommentVNode("", true),
          (_unref(userStore).user.id > 0 && _unref(userStore).admin_info_modal_open)
            ? (_openBlock(), _createBlock(AdminClientInfoModal, { key: 2 }))
            : _createCommentVNode("", true),
          (_unref(fileBrowserStore).openModal)
            ? (_openBlock(), _createBlock(FileBrowser, { key: 3 }))
            : _createCommentVNode("", true),
          (_unref(brakeStore).show)
            ? (_openBlock(), _createBlock(EmergencyBrakeModal, { key: 4 }))
            : _createCommentVNode("", true),
          (_unref(customerStore).showModal)
            ? (_openBlock(), _createBlock(CustomerModal, { key: 5 }))
            : _createCommentVNode("", true),
          (_unref(customerReceiptStore).showModal)
            ? (_openBlock(), _createBlock(CustomerReceiptConfirmation, { key: 6 }))
            : _createCommentVNode("", true),
          (_unref(ordersStore).isShowingOrderId)
            ? (_openBlock(), _createBlock(OrderModal, {
                key: 7,
                onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(ordersStore).closeOrderModal())),
                orderId: _unref(ordersStore).isShowingOrderId
              }, null, 8, ["orderId"]))
            : _createCommentVNode("", true),
          _createVNode(ConfirmationModal, {
            show: _unref(warningStore).showWarning,
            onCancel: _cache[1] || (_cache[1] = ($event: any) => (_unref(warningStore).showWarning = false)),
            onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_unref(warningStore).showWarning = false)),
            title: _unref(warningStore).warningTitle,
            description: _unref(warningStore).warningDescription
          }, null, 8, ["show", "title", "description"]),
          _createVNode(RiceCookerUpdateModal)
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})